/**
 * Registration Profile Fields Entrypoint
 *
 * Vite entrypoint loaded by `authentication.html.erb`, the layout shared by
 * every Devise page. It mounts the vanilla-TS controls behind the shared
 * registration field block (Country + Preferred language pickers, role card
 * grid, conditional social handle).
 *
 * Deliberately NOT Stimulus: `@hotwired/stimulus` is not in `package.json` and
 * `importmap-rails` is not in the Gemfile, so a `data-controller` attribute
 * would be inert on these pages. A Vite entrypoint is the only pattern that
 * works here, and mirrors `consent.ts`.
 *
 * Mounting is a no-op on auth pages that do not render the partial (login,
 * password reset, confirmations).
 */

import { mountRegistrationProfileFields } from "../app/registration";

function boot(): void {
  mountRegistrationProfileFields(document);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
